import React, {useEffect} from 'react';
import Banners from "../../components/Categories/Banners";
import Trending from "../../components/Categories/Trending";
import Categories from "../../components/Categories/PopularCategories";
import Offers from "../../components/Categories/Offers"
import { Footer } from '../../components';
import './index.css'
import Features from '../../components/Categories/Features';
import Collections from '../../components/Categories/Collections';
import Customers from '../../components/Categories/Customers';



const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []) 
  return (
    <div className='homepage font-poppins'>
      <div className='homepage2'>
        <Features  />
        <Collections/>
        <Categories/>
        <Customers/>
      </div>
    </div>
  );
};

export default HomePage;
